<template>
  <div>
    <div v-if="unit">
      <p class="lead text-center">{{ unit.description }}</p>
      <table class="table">
        <tr>
          <th>{{ $t("grid.slots.info.company") }}</th>
          <td>{{ unit.company || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.latitude") }}</th>
          <td>{{ unit.coordinates ? unit.coordinates.lat : (unit.lat || " - ") }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.longitude") }}</th>
          <td>{{ unit.coordinates ? unit.coordinates.lng : (unit.lng || " - ") }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.address") }} 1</th>
          <td>{{ unit.address_1 || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.address") }} 2</th>
          <td>{{ unit.address_2 || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.exterior_number") }}</th>
          <td>{{ unit.exterior_number || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.suburb") }}</th>
          <td>{{ unit.suburb || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.municipality") }}</th>
          <td>{{ unit.municipality ? unit.municipality.name : " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.postal_code") }}</th>
          <td>{{ unit.postal_code || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.country") }}</th>
          <td>{{ unit.country ? unit.country.name : " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("grid.slots.info.region") }}</th>
          <td>{{ unit.region ? unit.region.name : " - " }}</td>
        </tr>
        <tr>
          <th>REMS</th>
          <td>{{ unit.rems }}</td>
        </tr>
        <tr>
          <th>SIRH</th>
          <td>{{ unit.sirh}}</td>
        </tr>
        <tr>
          <th>Id SEPROBAN</th>
          <td>{{ unit.id_seproban}}</td>
        </tr>
      </table>
      <p
        class="text-header text-center"
        style="margin-top: 5px; cursor: pointer;"
        draggable="true"
        @dragstart="onDragStart(unit)"
      >
          <span class="text-id-alarm d-inline-flex align-items-center fw-bold clickable">
            {{ $t("grid.widgets_section.map.title") }}
            <feather-icon icon="MapIcon" size="16" class="copy-icon" />
        </span>
      </p>
    </div>
    <div class="pb-2 text-center" v-else>
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import axios from "@axios";
import layoutMixin from "@/mixins/layoutMixin";
import { SLOT_TYPES } from "@/config/layoutConfig";
import RiskFormAnswers from "@/components/BuildRiskForm/RiskFormAnswers.vue";

export default {
  mixins:[layoutMixin],
  props: {
    data: Object,
  },
  components: {
    RiskFormAnswers,
    BSpinner,
  },
  data() {
    return {
      unit: null,
    };
  },
  mounted() {
    // Si data.url existe, hacer la petición (comportamiento original)
    if (this.data.url) {
      const params = {
        with: ['lastRiskEvaluation']
      }

      axios.get(`${this.data.url}`, { params }).then(({ data }) => {
        this.unit = data.data;
        this.$emit('set-unit', data.data);
      });
    } else {
      // Si no hay URL, usar la data directamente
      this.unit = this.data;
      this.$emit('set-unit', this.data);
    }
  },
  methods:{
    onDragStart(unit) {
      const { coordinates } = unit;
      const data = {
        data: {
          center: {
            lat: parseFloat(coordinates.lat),
            lng: parseFloat(coordinates.lng),
          },
          zoom: 20,
        },
        unitId: unit.id,
      }

      this.setSlotData(
        SLOT_TYPES.UNITS_MAP,
        `Mapa de la instalación`,
        data
      );
    }
  }
}
</script>

<style scoped lang="scss">

.lead {
  font-size: 1.25rem;
}

.dark-layout {
  color: #333;
  & .lead {
    color: #ddd;
  }
}
</style>
